// extracted by mini-css-extract-plugin
export default {"preview":"Preview_preview__NN7YM","title":"Preview_title__vL9SH","footer":"Preview_footer__pB+Ge"};